import type { AgentRoleAssetListFilters, DashboardRolloutHealthFilters, DashboardTopListKind } from './types';

export const CLAUDE_CODE_DASHBOARD_QUERY_KEYS = {
  overview: (windowDays: number) => ['claude-code-dashboard', 'overview', windowDays] as const,
  costGovernance: (windowDays: number, limit: number) =>
    ['claude-code-dashboard', 'cost-governance', windowDays, limit] as const,
  rolloutHealth: (windowDays: number, filters: DashboardRolloutHealthFilters) =>
    [
      'claude-code-dashboard',
      'rollout-health',
      windowDays,
      filters.role ?? '',
      filters.pluginVersion ?? '',
      filters.mcpStatus ?? '',
      filters.sortBy ?? '',
      filters.limit ?? 50,
      filters.offset ?? 0,
    ] as const,
  topList: (kind: DashboardTopListKind, windowDays: number, limit: number, offset: number) =>
    ['claude-code-dashboard', 'top-list', kind, windowDays, limit, offset] as const,
  assetEvolutionCandidates: (windowDays: number, limit: number) =>
    ['claude-code-dashboard', 'asset-evolution-candidates', windowDays, limit] as const,
  employeeSummary: (employeeId: string, windowDays: number) =>
    ['claude-code-dashboard', 'employee-summary', employeeId, windowDays] as const,
  employeeSessions: (employeeId: string, windowDays: number, limit: number, offset: number) =>
    ['claude-code-dashboard', 'employee-sessions', employeeId, windowDays, limit, offset] as const,
  sessionEvents: (sessionId: string, limit: number) =>
    ['claude-code-dashboard', 'session-events', sessionId, limit] as const,
  skillProposals: (status: string, proposalSource: string, employeeId: string, role: string, limit: number) =>
    ['claude-code-dashboard', 'skill-proposals', status, proposalSource, employeeId, role, limit] as const,
  skillProposalDetail: (proposalId: string) => ['claude-code-dashboard', 'skill-proposal-detail', proposalId] as const,
  roleAssets: (filters: AgentRoleAssetListFilters) =>
    [
      'claude-code-dashboard',
      'role-assets',
      filters.kind ?? '',
      filters.scope ?? '',
      filters.status ?? '',
      filters.role ?? '',
      filters.adapter ?? '',
      filters.limit ?? 250,
    ] as const,
  roleAssetDetail: (assetId: string) => ['claude-code-dashboard', 'role-asset-detail', assetId] as const,
};
